import {logger, loggerRT} from './biLogger.config';
import biLoggerMiddleware from './biLogger.middleware';

export {
  logger,
  loggerRT,
  biLoggerMiddleware
};



// WEBPACK FOOTER //
// ./chat-app/biLogger/index.js